import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import { useNavigate } from "react-router-dom";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
      label: 'SLOC',
      attr: 'service_location_location',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created Date & Time',
      attr: 'created_at',
    },
  ]

  return <>

    <ListingPageComponent
      key={PAGES.WarehousesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.WarehousesListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Warehouses' }]}
      listingMutation={getApi('warehouses')}
      className="warehouses-listing-page"
      contentHeading="All Warehouses - Results"
      headers={headers}
      recordsKey="cs_ware_houses"
      searchBy={['ID (Case Sensitive)', 'SLOC']}
    />
  </>
};

export default Index;
